import { useCallback } from 'react';
import { BackHandler, Platform } from 'react-native';
import { useFocusEffect } from 'expo-router';
import { useModalStore } from '@/store';

// Internal onboarding pages share a route. Android Back should follow those
// pages while this route is focused, and leave open dialogs in control.
export default function useOnboardingBack(onBack, enabled = true) {
  useFocusEffect(useCallback(() => {
    if (Platform.OS !== 'android' || !enabled) return undefined;
    const subscription = BackHandler.addEventListener('hardwareBackPress', () => {
      if (useModalStore.getState().isOpen) return false;
      return onBack();
    });
    return () => subscription.remove();
  }, [onBack, enabled]));
}
